import styled from '@emotion/styled/macro';
import { forPhoneOnly, Spinner, Variables } from '@enter/core';
import { PageLayout } from 'components';

export const Wrapper = styled(PageLayout)`
    background-color: ${Variables.Colors.white};
    padding: 0;
    height: calc(100vh - ${Variables.topnavSize});

    ${forPhoneOnly(`
        height: calc(100vh - ${Variables.topnavSize});
    `)};
`;

export const Cell = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    flex-grow: 1;
    /* padding: 4px 0px; */
`;

export const Loader = styled(Spinner)`
    flex-grow: 0;
    margin-top: 40%;
`;

export const Expand = styled.div`
    display: flex;
    flex-direction: row;
    align-items: stretch;
    padding: 0;
`;
